<template>
  <v-dialog
    v-model="dialog"
    :persistent="loading"
    width="478">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="brandList.length > 0"
        v-bind="attrs"
        :ripple="false"
        color="error"
        depressed
        rounded
        v-on="on">
        <v-icon left>
          mdi-delete-outline
        </v-icon>
        ลบแบรนด์ ({{ brandList.length }})
      </v-btn>
      <v-btn
        v-else
        v-bind="attrs"
        :ripple="false"
        color="error"
        icon
        v-on="on">
        <v-icon>
          mdi-delete-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card class="p-5">
      <v-card-title>
        <v-spacer />
        <v-btn
          color="#A9A9A9"
          x-small
          icon
          @click="closeDialogs()">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="d-flex align-center justify-center mb-3">
          <v-icon
            color="error"
            size="60"
            center>
            $snt_trash
          </v-icon>
        </div>
        <div class="text-center mt-4">
          <div class="subtitle-1 secondary--text font-weight-medium">
            <span v-if="brandId">
              คุณต้องการลบแบรนด์ {{ brandName }}?
            </span>
            <span v-else>
              คุณต้องการลบแบรนด์จำนวน ({{ brandList.length }}) ชิ้น?
            </span>
          </div>
          <div class="subtitle-2 grey--text font-weight-regular">
            แบรนด์ในสินค้าทั้งหมดจะถูกลบด้วย
          </div>
        </div>

        <v-divider class="mt-8" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="loading"
          rounded
          text
          @click="closeDialogs()">
          ยกเลิก
        </v-btn>
        <v-btn
          height="40"
          elevation="0"
          color="error"
          :ripple="false"
          :loading="loading"
          :disabled="loading"
          rounded
          @click.prevent="onSubmit()">
          ยืนยันลบข้อมูล
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DELETE_PRODUCT_BRAND } from '@/resources/graphql'

export default {
  props: {
    brandList: {
      type: Array,
      default: () => []
    },
    brandId: {
      type: String,
      default: ''
    },
    brandName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      errors: []
    }
  },
  computed: {
    ids () {
      if (this.brandList.length > 0) {
        return this.brandList.map(({ id }) => id)
      }
      return [this.brandId]
    }
  },
  methods: {
    closeDialogs () {
      this.dialog = false
    },
    async onSubmit () {
      this.loading = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: DELETE_PRODUCT_BRAND,
          variables: {
            input: {
              ids: this.ids
            }
          }
        })

        if (data.deleteProductBrand.errors.length > 0) {
          throw new Error(data.deleteProductBrand.errors)
        } else {
          this.$emit('onRefetch')
          this.$emit('deleteSuccess')
          this.closeDialogs()
        }
      } catch ({ message }) {
        if (message.length > 0) {
          this.errors = message.split(',')
          this.errors.forEach((errorMessage) => {
            this.$notify.error(errorMessage)
          })
        }
      }
      this.loading = false
    }
  }
}
</script>
